export const IS_AUTO_UPDATE = true;
export const PAGE_SIZE = 25;
